import { ContactSec4 } from "../ContactUs/ContactSec4";
import { Footer } from "../Footer";
import { MainLayout } from "../MainLayout";
import AboutIntro from "./AboutIntro/AboutIntro";
import B2BServices from "./B2BServices/B2BServices";
import CTASection from "./CTASection/CTASection";
import HomeAwards from "./HomeAwards";
import HomeMapSection from "./HomeMapSection/HomeMapSection";
import HomeReelSection from "./HomeReelSection/HomeReelSection";
import HomeExpertise from "./HomeExpertise/HomeExpertise";
import { HomeLocalExpertise } from "./HomeLocalExpertise";
import PackagesSection from "./PackagesSection/PackagesSection";
import WhyChooseHome from "./WhyChooseHome/WhyChooseHome";
import HomeTestimonial from "./HomeTestimonial/HomeTestimonial";


export const Home = () => {
  return (
    <>
      <MainLayout
       bgVideo="https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/BB%20DMC%20Website%20Video_Version%2002.mp4"
        text1={"YOUR GLOBAL DMC PARTNER"}
        text2={"13+ Years of On-Ground Excellence "}
        text3={
          "Supporting travel agents with confirmed availability, seamless coordination and reliable execution across leisure, MICE, and group travel. "
        }
        button={true}
      />
      <AboutIntro />
      <B2BServices />
      <CTASection />
      <HomeMapSection/>
      <PackagesSection/>
      <HomeLocalExpertise />
      <WhyChooseHome />
      <HomeReelSection/>
      <HomeTestimonial/>
      <HomeExpertise />
      <ContactSec4/>
      <HomeAwards/>
      <Footer />
    </>
  );
};
